import React from 'react'

import { LightThemeProvider } from '@qflow/theme'

import { AssigneeNoRecordsAssigned } from 'portal/components/AssigneeNoRecordsAssigned'
import { Sidebar } from 'portal/components/Sidebar'
import { PageContainer } from 'portal/pages/PageContainer'

export const AssigneeNoRecordsAssignedPage = () => {
  return (
    <LightThemeProvider>
      <Sidebar noMenuItems={true} />
      <PageContainer>
        <AssigneeNoRecordsAssigned />
      </PageContainer>
    </LightThemeProvider>
  )
}
